import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box } from '@material-ui/core';
import React from 'react';
import NumberFormat from 'react-number-format';

const NumberOrTextCellRenderer: React.FC<ICellRendererParams> = (props) => {
  return (
    <>
      {typeof props.value === 'number' ? (
        <NumberFormat value={props.value} displayType={'text'} thousandSeparator={true} />
      ) : (
        <Box>{props.value}</Box>
      )}
    </>
  );
};

export default NumberOrTextCellRenderer;
